// extracted by mini-css-extract-plugin
export default {"container":"styles_container__SuqJP","title":"styles_title__6TgAl","subTitle":"styles_subTitle__CsPBf"};